import { ReactNode } from 'react';

import {
  ChartWrapper,
  Container,
  FormWrapper,
  HeaderWrapper,
  SidebarWrapper,
  Wrapper,
} from './ReportSection.styled';

type ReportSectionVariant = 'default';

type ReportSectionProps = {
  backgroundImage?: string;
  chartHasBorderTop?: boolean;
  chartHeader?: ReactNode;
  chartFooter?: ReactNode;
  header?: ReactNode;
  chart: ReactNode;
  sidebar?: ReactNode;
  variant?: ReportSectionVariant;
};

export function ReportSection({
  backgroundImage,
  chart,
  chartHasBorderTop,
  chartHeader,
  chartFooter,
  header,
  sidebar,
  variant = 'default',
}: ReportSectionProps) {
  return (
    <Container
      $backgroundImage={backgroundImage}
      $hasBorderTop={chartHasBorderTop}
      $variant={variant}
    >
      <Wrapper>
        {header ? <HeaderWrapper>{header}</HeaderWrapper> : null}
        {sidebar ? (
          <SidebarWrapper>
            <FormWrapper>{sidebar}</FormWrapper>
          </SidebarWrapper>
        ) : null}
        <ChartWrapper $hasBorderTop={chartHasBorderTop} $variant={variant}>
          {chartHeader}
          {chart}
          {chartFooter}
        </ChartWrapper>
      </Wrapper>
    </Container>
  );
}
